import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Trésorerie freelance et indépendant : gérer les hauts et les bas | Trezoone',
    description: 'En freelance, les revenus sont irréguliers mais les charges fixes arrivent chaque mois. Voici comment lisser votre trésorerie et ne jamais être pris au dépourvu.',
    canonical: '/tresorerie-freelance-independant',
    keywords: 'trésorerie freelance, trésorerie indépendant, gestion cash freelance, revenus irréguliers trésorerie, auto-entrepreneur trésorerie',
  },
  hero: {
    tag: 'Trésorerie freelance',
    title: 'Vos revenus sont irréguliers. Vos charges, elles, ne le sont pas.',
    subtitle: 'C\'est le paradoxe du freelance : des mois à 8 000 €, des mois à 2 000 €. Avec les mêmes charges à payer. Voici comment lisser ça.',
    ctaLabel: 'Stabiliser ma trésorerie',
  },
  pilierLink: { label: 'Gestion trésorerie TPE', href: '/gestion-tresorerie-tpe' },
  sections: [
    {
      type: 'explain',
      title: 'La règle des 3 mois pour les freelances',
      content: 'La règle de base pour sécuriser la trésorerie d\'un freelance :',
      items: [
        'Calculez vos charges mensuelles incompressibles (cotisations, loyer, abonnements)',
        'Multipliez par 3 → c\'est votre réserve de sécurité minimum',
        'Ne touchez jamais à cette réserve sauf urgence absolue',
        'En mois "gros" : reconstituez la réserve avant de vous payer plus',
        'Exemple : charges 2 500 €/mois → réserve minimum 7 500 €',
      ],
    },
    {
      type: 'example',
      title: 'Plan de trésorerie freelance — exemple sur 6 mois',
      content: 'Développeur freelance, CA très variable, charges fixes 2 200 €/mois.',
      items: [
        'Janvier : 0 € (congés) → on puise dans la réserve',
        'Février-Mars : 6 000 €/mois de CA → reconstitution de réserve',
        'Avril : 9 000 € (gros projet) → mise en réserve + paiement cotisations',
        'Mai-Juin : 4 000 €/mois → situation normale',
        'Avec Trezoone : calcul automatique de la "part à mettre de côté" chaque mois',
      ],
    },
    {
      type: 'midcta',
      title: 'Vos revenus varient de 2 000 € à 8 000 € selon les mois — ne laissez plus les creux vous surprendre',
      content: 'Trezoone calcule automatiquement votre réserve de sécurité et vous alerte quand elle est insuffisante pour absorber un mois sans revenu.',
    },
    {
      type: 'solution',
      title: 'Trezoone adapté aux indépendants',
      content: 'Un outil simple pour les freelances qui n\'ont pas le temps de faire de la compta.',
      items: [
        'Suivi des encaissements et décaissements en temps réel',
        'Calcul automatique de votre réserve de sécurité',
        'Alerte quand la réserve descend sous le seuil minimum',
        'Prévision de vos cotisations et charges à venir',
        'Vue mensuelle claire pour anticiper les mois creux',
      ],
    },
    {
      type: 'cluster',
      title: 'Ressources pour les indépendants et TPE',
      links: [
        { label: 'Gestion trésorerie TPE', href: '/gestion-tresorerie-tpe' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
        { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
        { label: 'Manque de trésorerie', href: '/manque-tresorerie' },
        { label: 'Trésorerie startup', href: '/tresorerie-startup' },
        { label: 'Logiciel trésorerie', href: '/logiciel-tresorerie' },
        { label: 'Suivi trésorerie entreprise', href: '/suivi-tresorerie-entreprise' },
      ],
    },
    {
      type: 'cta',
      title: 'Ne laissez plus les mois creux vous surprendre',
      content: 'Trezoone garde un œil sur votre trésorerie pendant que vous travaillez. Essai gratuit 14 jours.',
    },
  ],
  relatedLinks: [
    { label: 'Gestion trésorerie TPE', href: '/gestion-tresorerie-tpe' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
    { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
    { label: 'Manque de trésorerie', href: '/manque-tresorerie' },
    { label: 'Trésorerie startup', href: '/tresorerie-startup' },
    { label: 'Logiciel trésorerie', href: '/logiciel-tresorerie' },
    { label: 'Suivi trésorerie entreprise', href: '/suivi-tresorerie-entreprise' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function TresorerieFreelancePage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
